function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 0a8 8 0 110 16A8 8 0 018 0zm0 1.371A6.629 6.629 0 108 14.63 6.629 6.629 0 008 1.37zm-.484 3.2c.365 0 .66.28.66.624v2.701h3.736c.364 0 .66.28.66.623 0 .345-.296.624-.66.624H7.516c-.364 0-.659-.28-.659-.624V5.195c0-.344.295-.624.66-.624z"
}));